import BaseObject from "./models/BaseObject";

export class DialogData {
  content: any;

  // returning false avoid closing dialog

  onOk: (() => boolean) | undefined;
  onAbort: (() => boolean) | undefined;
}

export default class DialogManager extends BaseObject {
  private nextDialogKey = 0;
  public get className(): string {
    return "DialogManager";
  }

  get currentDialog(): any | undefined {
    if (this.dialogStack.length > 0) {
      return this.dialogStack[this.dialogStack.length - 1];
    } else {
      return undefined;
    }
  }

  set currentDialog(value: any | undefined) {
    this.dialogStack = value ? [{ ...value, key: ++this.nextDialogKey }] : [];
  }

  dialogStack = new Array<{
    key: number;
    isModal: boolean;
    doCenter: boolean;
    closeOnClickOutside: boolean;
    dialog: any;
    dialogId: string;
    resolve?: ((ok: boolean) => void) | undefined;
    onClose?: (() => boolean) | undefined;
    preserveOnOpen?: boolean;
  }>();

  get lastStackEntry() {
    if (this.dialogStack.length > 0) {
      return this.dialogStack[this.dialogStack.length - 1];
    } else {
      return undefined;
    }
  }

  get isOpen(): boolean {
    return this.lastStackEntry !== undefined;
  }

  get doCenter(): boolean {
    return this.lastStackEntry ? this.lastStackEntry.doCenter : false;
  }
  set doCenter(value: boolean) {
    if (this.lastStackEntry) {
      this.lastStackEntry.doCenter = value;
    }
  }

  get closeOnClickOutside(): boolean {
    return false;
  }

  get isModal(): boolean {
    return this.lastStackEntry ? this.lastStackEntry.isModal : false;
  }

  get resolve(): ((ok: boolean) => void) | undefined {
    return this.lastStackEntry ? this.lastStackEntry.resolve : undefined;
  }
  set resolve(value: ((ok: boolean) => void) | undefined) {
    if (this.lastStackEntry) {
      this.lastStackEntry.resolve = value;
    }
  }

  get onClose(): (() => boolean) | undefined {
    return this.lastStackEntry ? this.lastStackEntry.onClose : undefined;
  }
  set onClose(value: (() => boolean) | undefined) {
    if (this.lastStackEntry) {
      this.lastStackEntry.onClose = value;
    }
  }

  closeDialog(result?: boolean) {
    if (this.onClose) {
      this.onClose();
    }

    this.onClose = undefined;

    //
    // resolve openDialog Promise
    //
    if (this.resolve) {
      const r = this.resolve;
      this.resolve = undefined;
      r(result === undefined ? true : result);
    }

    state.guideMode.raiseSync({ id: "dialogClose" });

    this.dialogStack.pop();

    this.showTopDialog();

    this.raiseOnChangeUI();
  }

  isVisible(dialog: any): boolean {
    return this.currentDialog === dialog;
  }

  hideAllDialogsExceptOf(dialogId: string) {
    //
    // hide all other dialogs
    //
    for (const dialog of this.dialogStack) {
      if (dialog.dialogId != dialogId) {
        const dialogElement = document.getElementsByClassName(
          "dialog-" + (dialog.dialogId || "main"),
        )[0] as HTMLDivElement;
        if (dialogElement) {
          dialogElement.style.display = "none";
        }
      }
    }
  }

  showTopDialog() {
    const dialog = this.dialogStack[this.dialogStack.length - 1];
    if (dialog) {
      const dialogElement = document.getElementsByClassName(
        "dialog-" + (dialog.dialogId || "main"),
      )[0] as HTMLDivElement;
      if (dialogElement) {
        dialogElement.style.display = "flex";
      }
    }
  }

  pushDialog(dialogId: string, dialog: any, modal?: boolean, closeOnClickOutside?: boolean): Promise<boolean> {
    //
    // hide all other dialogs
    //
    this.hideAllDialogsExceptOf(dialogId);

    return this.xOpenDialog(dialogId, true, dialog, modal, closeOnClickOutside);
  }

  openDialog(dialog: any, modal?: boolean, closeOnClickOutside?: boolean): Promise<boolean> {
    return this.xOpenDialog("", false, dialog, modal, closeOnClickOutside);
  }

  xOpenDialog(
    dialogId: string,
    doPush: boolean,
    dialog: any,
    modal?: boolean,
    closeOnClickOutside?: boolean,
  ): Promise<boolean> {
    if (!doPush && this.dialogStack.some((entry) => entry.preserveOnOpen)) {
      doPush = true;
      this.hideAllDialogsExceptOf(dialogId);
    }
    if (!doPush) {
      this.dialogStack = [];
    }

    const p = new Promise<boolean>((resolve) => {
      this.dialogStack.push({
        key: ++this.nextDialogKey,
        dialogId: dialogId,
        dialog: dialog,
        isModal: modal != false,
        doCenter: true,
        closeOnClickOutside: closeOnClickOutside === undefined ? modal != false : closeOnClickOutside,
        resolve: resolve,
      });

      this.raiseOnChangeUI();
    });

    return p;
  }

  clear() {
    while (this.dialogStack.length > 0) {
      this.closeDialog(false);
    }
  }
}
